<template>
  <v-card @click="clickItem(profit._id)" elevation="3">
    <v-card-text>
      <v-row>
        <v-col cols="9" class="pb-0">
          <span class="font-weight-bold">{{ profit.protocolName }} </span>
        </v-col>
        <v-col
          cols="3"
          class="pb-0 text-end"
          v-if="profit.status == 'NEW' && shouldShow"
        >
          <v-menu transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" x-small>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, i) in menu" :key="i">
                <v-list-item-title @click="actionProfit(item.value)">{{
                  item.name
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <span class="text-caption">{{ getFormatted(profit.createdAt) }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-0">
          <span class="text-caption">{{ profit.code }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 text-end">
          <span class="primary--text font-weight-bold">{{
            getStatus(profit.status)
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    menu: [
      { name: "Actualizar", value: "edit" },
      // { name: "Agregar versión", value: "add_version" },
    ],
    shouldShow: true,
  }),
  props: {
    profit: {
      type: Object,
      required: false,
    },
  },
  created() {
    this.menu = [
      { name: this.translations.label_update, value: "edit" },
      // { name: this.translations.label_add_version, value: "add_version" },
    ];
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.role == "ORG_USER") {
      this.shouldShow = false;
    }
  },
  methods: {
    actionProfit(value) {
      switch (value) {
        case "edit":
          this.$router.push(`/profit-form-update/${this.profit._id}`);
          break;
        case "add_version":
          this.$router.push(`/profit-form-addVersion/${this.profit._id}`);
          break;
      }
    },
    clickItem(value) {
      this.$router.push(`/profit-detail/${value}`);
    },
    getFormatted(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    getStatus(value) {
      return this.translations.status_profits[value];
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
};
</script>

<style scoped></style>
